/**
 * Preserves the document scroll offset across a fullscreen overlay lock.
 *
 * While any fullscreen overlay is registered, `#app` carries `vf-fullscreen-open`,
 * whose `overflow: hidden` collapses the document's scrollable height to a single
 * viewport. The browser then clamps the scroll offset to 0, and removing the class
 * on close does not put it back — moderators lose their place in the queue or
 * saved search (CM-1743).
 *
 * @param {Window} scrollTarget - window-like object exposing `scrollY` and `scroll()`
 * @returns {{capture: function, restore: function}} lock that remembers the offset between the two calls
 */
export function createScrollLock(scrollTarget = window) {
    let capturedOffset = 0;

    return {
        capture() {
            capturedOffset = scrollTarget.scrollY;
        },

        restore() {
            const offset = capturedOffset;
            capturedOffset = 0;

            if (offset > 0) {
                scrollTarget.scroll({ top: offset });
            }
        },
    };
}
